import _ from "lodash";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL } from "Constants";

export var SURVEY_LIST = "SURVEY_LIST";
export var SURVEY_RESPONSE_DATA = "SURVEY_RESPONSE_DATA"; //

/****  Survey response display and download.  ****/
export function fetchSurveyResponse(session, dataobj, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    formid: dataobj.formid,
    formtype: dataobj.formtype,
    formnumber: dataobj.formnumber,
    eventid: session.eventid,
    type: "fetchSurveyResponse",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (res) => {
        dispatch({
          type: SURVEY_RESPONSE_DATA,
          payload: { data: res.resource },
        });
        callback({
          error: 0,
          message: "Survey response !",
          data: res.resource,
        });
      },
      (error) => {}
    );
  };
}

export function fetchSurvey(session, pageCount = 0, callback) {
  let itemCount = 50;
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    limit: perPage,
    offset: offset,
    eventid: session.eventid,
    type: "fetchSurveyForm",
    isadmin: true,
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (res) => {
        dispatch({
          type: SURVEY_LIST,
          payload: { data: res.response, count: res.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function changeSurveyFormStatus(session, value, id, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (formnumber=${id}) AND (formtype='survey')`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms?filter=(${filter})`;
  var data = { resource: { ...value } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (res) => {
        callback({ success: 1, response: res });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function deleteSurveyForm(session, id, callback) {
  var filter = encodeURI(`(formnumber=${id}) AND (formtype='survey')`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms?filter=(${filter})`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

// Update Display Order by Draginng List Row
export function updateSortedSurvey(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms`;
  var data = _.map(values, (obj) => ({
    formid: obj.formid,
    displayorder: obj.displayorder,
    eventid: session.eventid,
  }));
  var body = { resource: data };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
